/**
 * Create and return a shallow copy of the original array with new items
 * inserted at index.
 *
 * @template T
 * @param source Array to be used as a source
 * @param index Index at which to begin adding new items
 * @param items Single item or array of items to add
 * @param replaceAtIndex If true item at index will be replaced, if false item
 *   at index will be moved after the new items.
 * @returns Into array new array
 */
export function insertIntoArray<T>(
  source: T[],
  index: number,
  items: T | T[],
  replaceAtIndex = false,
): T[] {
  return [
    ...source.slice(0, index),
    ...spreadIfArray(items),
    ...source.slice(replaceAtIndex ? index + 1 : index),
  ];
}

function spreadIfArray<T>(t: Array<T> | T): T[] {
  return Array.isArray(t) ? t : [t];
}

export function getUniqueValues(arr: string[]): string[] {
  return Array.from(new Set(arr));
}

/**
 * Returns an array of strings or undefined. Required for store.
 *
 * If the input value is undefined, an empty array, or contains only null
 * values, this function will return undefined. Otherwise, it will return a
 * filtered and mapped array of strings.
 *
 * @returns A filtered and mapped array of strings, or undefined if the input
 *   value is undefined, an empty array, or contains only null values.
 */
export function filterNonNullStrings(
  value: (string | null)[] | null | undefined,
): string[] | undefined {
  if (!value || !value.length) return undefined;
  return value.filter((val) => !!val).map((val) => val as string);
}
